import { render } from "./XIconSolidGraduationCap.vue?vue&type=template&id=a7023e52"
import script from "./XIconSolidGraduationCap.vue?vue&type=script&lang=js"
export * from "./XIconSolidGraduationCap.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidGraduationCap.vue"]])

export default __exports__